import { render, staticRenderFns } from "./VideoBox.vue?vue&type=template&id=52f0eb6f&scoped=true"
import script from "./VideoBox.vue?vue&type=script&lang=js"
export * from "./VideoBox.vue?vue&type=script&lang=js"
import style0 from "./VideoBox.vue?vue&type=style&index=0&id=52f0eb6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f0eb6f",
  null
  
)

export default component.exports